$(function() {
	$(".validationform").length && $(".validationform").validate({
		rules: {
			name: {
				required: !0
			},
			email: {
				required: !0,
				email: !0
			},
			comment: {
				required: !0
			}
		},
		messages: {
			name: {
				required: "名前を入力してください"
			},
			email: {
				required: "メールアドレスを入力してください",
				email: "メールアドレスを正確に入力してください"
			},
			comment: {
				required: "お問い合わせ内容を入力してください"
			}
		},
		errorPlacement: function(e, r) {
			"radio" === r.attr("name") ? e.insertAfter("#radioErr") : "checkbox[]" === r.attr("name") ? e.insertAfter("#checkboxErr") : e.insertAfter(r)
		},
		submitHandler: function(e, r, a) {
			grecaptcha.ready(function() {
				grecaptcha.execute("", {
					action: "submit"
				}).then(function(e) {
					const r = document.querySelector("#recaptcha_form"),
						a = document.createElement("input");
					a.type = "hidden", a.name = "recaptcha_response", a.value = e, r.appendChild(a), r.submit()
				})
			})
		}
	})
});
//# sourceMappingURL=validate-config.js.map